import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
    SxProps,
    Theme,
} from "@mui/material";
import ReinovaButton from "./ReinovaButton";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

const CareersFormStyle: Record<string, SxProps<Theme>> = {
    container: {
        display: "flex",
        // textAlign: "left",
        flex: 1,
        flexDirection: "column",
        height: "100%",
    },
    formTitle: {
        fontSize: "1.5rem",
    },
    formSubtitle: {
        fontSize: "1rem",
        color: "#bababa",
    },
    formTitleMobile: {
        fontSize: "20px",
    },
    formSubtitleMobile: {
        fontSize: "16px",
        color: "#bababa",
    },
    formContainer: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        marginTop: "50px"
    },
    formData: {
        marginTop: "20px",
    },
    formFooter: {
        alignItems: "center",
        // justifyContent: "center",
        // textAlign: "center",
    },
    formFooterConditions: {
        fontSize: "0.9rem",
        color: "#bababa",
        textAlign: "left",
    },
    formItem: {
        marginBottom: "10px",
        marginTop: "10px",
    },
};

interface Props {
    // handleSubmit: (name: string, email: string, file: string) => void;
    positionName: string
}

// Contenuto del box a destra nella pagina di dettaglio di una posizione aperta
const CareersForm: React.FC<Props> = ({ positionName }) => {
    const { t } = useTranslation();

    return (
        <Box sx={CareersFormStyle.container}>
            <Typography
                sx={
                    isMobile
                        ? CareersFormStyle.formTitleMobile
                        : CareersFormStyle.formTitle
                }
            >
                {t("careersform.title")}
            </Typography>
            <Box sx={CareersFormStyle.formContainer}>
                <ReinovaButton
                    onClick={() => {
                        window.location.assign((t("careersform.mailto")).toString() + positionName);
                    }}
                    style={{
                        alignSelf: "center",
                        marginTop: isMobile ? "20px" : "0px",
                    }}
                >
                    {t("careersform.apply")}
                </ReinovaButton>
            </Box>
        </Box>
    );
};

export default CareersForm;
